import React from 'react';

export const Instagram = () => (
    <>
        <rect x='4' y='4' width='16' height='16' rx='4' />
        <circle cx='12' cy='12' r='3' />
        <line x1='16.5' y1='7.5' x2='16.5' y2='7.501' />
    </>
);